;
/*!
 * subitotexto.videotfo.js
 */
SubitoTexto.videoTfo = {
	init            : function () {
		var $ = jqPla,
			_this = SubitoTexto.videoTfo;

		_this.$videoTfoContainers = $( '.video-tfo' );

		if ( _this.$videoTfoContainers.length > 0 ) {

			_this.$transcriptBtns = $( '.video-transcript-toggler' );
			_this.$transcriptContainers = $( '.video-transcript' );

			//_this.$transcriptBtns.hide();
			_this.$transcriptContainers.hide();

			_this.bindEvents();
		}
	},
	bindEvents      : function () {
		var $ = jqPla,
			_this = SubitoTexto.videoTfo;

		_this.$videoTfoContainers.on( 'click', '.btn-play', function () {

			var $this = $( this ),
				$videoContainer = $this.parents( '.video-player' ),
				alreadySwitched = $this.hasClass( 'video-mode' );

			if ( !alreadySwitched ) {
				//$videoContainer.parents('.content-block').find('.video-transcript-toggler').show();
				_this.replaceWithVideo( $videoContainer );
			}
		} );

		_this.$transcriptBtns.on('click', function(e) {
			var $this = $(this),
				isActive = $this.hasClass('active'),
				$siblingTranscription = $this.siblings('.video-transcript');



			if(isActive) {
				$this.removeClass('active');
				_this.hideTranscript($siblingTranscription);
			} else {
				$this.addClass('active');
				_this.showTranscript($siblingTranscription);
			}
		});
	},
	replaceWithVideo: function ( $container, videoUrl ) {
		var $ = jqPla,
			_this = SubitoTexto.videoTfo;

		if ( typeof videoUrl == 'undefined' ) {
			videoUrl = $container.data( 'video-url' );
		}

		if ( typeof videoUrl == 'undefined' || videoUrl == '' ) {
			console.error( 'SUBITO: There is no video Url specified for this video block', $container );
		}
		var videoCcUrl = $container.data( 'video-cc-url' ),
			videoCcTag = videoCcUrl ? ' <track kind="captions" src="' + videoCcUrl + '" srclang="fr" label="Français">' : '',

			videoId = 'video-tfo-' + Math.floor( Date.now() / 10 ),
			videoTemplate = ' <video id="' + videoId + '" class="video-js" controls preload="auto"  data-setup="{}"> ' +
				'	<source src="' + videoUrl + '.mp4" type="video/mp4"> ' +
				'	<source src="' + videoUrl + '.webm" type="video/webm"> ' +
				videoCcTag +
				'</video>';

		$container.addClass( 'video-mode' );
		$container.html( videoTemplate );


		_this.currVideo = videojs( videoId, {
			'controls': true,
			'autoplay': true,
			'preload' : 'auto'
		}, function () {

		} );

		_this.currVideo.ready( function () {
			console.log( 'Video is ready!' )
			this.hotkeys( {
				volumeStep               : 0.1,
				seekStep                 : 5,
				enableModifiersForNumbers: false
			} );


			$container.find( '.video-js' ).focus();

			// VideoJS hasn't properly localized this part
			$( '.vjs-texttrack-settings' ).html( 'Paramètres de sous-titrage<span class="vjs-control-text">, ouvrir les paramètres des sous-titres transcrits</span>' );

			$( '.vjs-captions-button' ).find( 'li' ).each( function ( i, el ) {
				var $this = $( this ),
					textContent = $this.text(),
					isDeactivateBtn = textContent.indexOf( 'désactivés' ) > -1,
					isActivateBtn = textContent.indexOf( 'Français' ) > -1,
					$tempInternalSpan = $this.find( 'span' ).clone();

				console.log( $this, textContent, isDeactivateBtn, isActivateBtn, $tempInternalSpan );

				if ( isDeactivateBtn ) {
					$this
						.html( 'Désactivé' )
						.append( $tempInternalSpan );
				} else if ( isActivateBtn ) {
					$this
						.html( 'Activé' )
						.append( $tempInternalSpan );
				}


			} );
		} );


		// On pages with multiple video players, playing one didn't pause the others.
		if ( typeof _this.alreadyBoundMultiVideoSafety == 'undefined' || _this.alreadyBoundMultiVideoSafety ) {

			// https://coderwall.com/p/9loihg/video-js-disable-simultaneous-video-playback-html5-amp-flash
			$( 'audio,video' ).bind( 'play', function () {
				activated = this;
				$( 'audio,video' ).each( function () {
					if ( this != activated ) this.pause();
				} );
			} );

			_this.alreadyBoundMultiVideoSafety = true;
		}

	},

	hideTranscript: function ($transcriptContainer) {
		var $ = jqPla,
			_this = SubitoTexto.videoTfo;

		$transcriptContainer.hide().removeClass('active');
		PLA.UTILS.scrollTop.scrollTo($transcriptContainer.parents('.content-block'), -20, 300);

	},

	showTranscript: function ($transcriptContainer) {
		var $ = jqPla,
			_this = SubitoTexto.videoTfo;

		$transcriptContainer.show().addClass('active');


	},

};
